"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchList = fetchList;
exports.listAddress = listAddress;
exports.read = read;
exports.findCusMobile = findCusMobile;
exports.findOrAdd = findOrAdd;
exports.userDetail = userDetail;
exports.findCityByMobile = findCityByMobile;

var _request = _interopRequireDefault(require("@/utils/request"));

function fetchList(query) {
  return (0, _request.default)({
    url: '/customer/list',
    method: 'get',
    params: query
  });
}

function listAddress(query) {
  return (0, _request.default)({
    url: '/address/list',
    method: 'get',
    params: query
  });
}

function read(id) {
  return (0, _request.default)({
    url: '/customer/read',
    method: 'get',
    params: {
      id: id
    }
  });
}

function findCusMobile(id) {
  return (0, _request.default)({
    url: '/customer/findCusMobile',
    method: 'get',
    params: {
      id: id
    }
  });
}

function findOrAdd(mobile) {
  return (0, _request.default)({
    url: '/customer/findOrAdd',
    method: 'get',
    params: {
      mobile: mobile
    }
  });
}

function userDetail(data) {
  return (0, _request.default)({
    url: '/customer/userDetail',
    method: 'get',
    params: data
  });
}

function findCityByMobile(mobile) {
  return (0, _request.default)({
    url: '/customer/findCityByMobile',
    method: 'get',
    params: {
      mobile: mobile
    }
  });
}